module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town")]), _vm._v(" "), _c('p', {
    staticClass: "ctr",
    attrs: {
      "id": "pAjmp"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#RR_16",
      "id": "CC_16"
    }
  }, [_vm._v(" Hot Plate Hot Chocolate")])]), _vm._v(" "), _c('p', {
    staticClass: "tx6",
    attrs: {
      "id": "pASa5"
    }
  }, [_c('i', [_vm._v(" Folks will come knocking on your door for it. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAQ2"
    }
  }, [_c('b', [_vm._v(" 1 8-quart box nonfat dry milk ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "Aup8"
    }
  }, [_c('b', [_vm._v(" 1 pound confectioners’ sugar ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "A-Zq"
    }
  }, [_c('b', [_vm._v(" 11 ounces coffee creamer ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "pAdEq"
    }
  }, [_c('b', [_vm._v(" 2 pounds Nestle’s Quik ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx5",
    attrs: {
      "id": "A30Z"
    }
  }, [_c('b', [_vm._v(" 2 teaspoons cinnamon, optional ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pA4_v"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("M")]), _vm._v("ix all ingredients. Use ¼ cup mixture to 1 serving cup hot water. Stir.")]), _vm._v(" "), _c('p', {
    staticClass: "txrr",
    attrs: {
      "id": "pAqXR"
    }
  }, [_c('i', [_vm._v("Gary Wedemeyer—Fall Branch, Tennessee")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "AhU"
    }
  }, [_c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "pAfr"
    }
  }, [_c('i', [_vm._v("Barney gets a little sugar from Thelma Lou:")])]), _vm._v(" "), _c('table', {
    attrs: {
      "id": "pAxM"
    }
  }, [_c('tbody', {
    staticStyle: {
      "vertical-align": "top"
    },
    attrs: {
      "id": "AxM"
    }
  }, [_c('tr', {
    attrs: {
      "id": "tr-AxM-0"
    }
  }, [_c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "id": "td-AxM-0-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("THELMA LOU:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AxM-0-1"
    }
  }, [_vm._v("Barney, I brought you something I think you can handle even while you’re wearing that thing.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AxM-1"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2",
      "id": "td-AxM-1-0"
    }
  }, [_vm._v("(She hands him a huge milkshake.)")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AxM-2"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AxM-2-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AxM-2-1"
    }
  }, [_vm._v("Hey, with a straw. I never thought of that. What is it?")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AxM-3"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AxM-3-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("THELMA LOU:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AxM-3-1"
    }
  }, [_vm._v("Double-rich vanilla with two raw eggs.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AxM-4"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AxM-4-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AxM-4-1"
    }
  }, [_vm._v("Boy, that’s thick.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AxM-5"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2",
      "id": "td-AxM-5-0"
    }
  }, [_vm._v("(He stretches for it.)")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AxM-6"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AxM-6-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("THELMA LOU:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AxM-6-1"
    }
  }, [_vm._v("Oh, I’m sorry.")])]), _vm._v(" "), _c('tr', {
    attrs: {
      "id": "tr-AxM-7"
    }
  }, [_c('td', {
    attrs: {
      "id": "td-AxM-7-0"
    }
  }, [_c('p', {
    staticClass: "txtb"
  }, [_vm._v("BARNEY:")])]), _vm._v(" "), _c('td', {
    attrs: {
      "id": "td-AxM-7-1"
    }
  }, [_vm._v("Oh, that’s all right. It’s good practice for puckering, if you know what I mean.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3885ac8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter16.vue
// module id = 111
// module chunks = 0